__turbopack_context__.v({
  "container": "ExtendedSlider-module-scss-module__vFtvyG__container",
  "data": "ExtendedSlider-module-scss-module__vFtvyG__data",
  "disabledFooter": "ExtendedSlider-module-scss-module__vFtvyG__disabledFooter",
  "disabledSlider": "ExtendedSlider-module-scss-module__vFtvyG__disabledSlider",
  "footer": "ExtendedSlider-module-scss-module__vFtvyG__footer",
  "middleLabel": "ExtendedSlider-module-scss-module__vFtvyG__middleLabel",
  "slider": "ExtendedSlider-module-scss-module__vFtvyG__slider",
  "textInput": "ExtendedSlider-module-scss-module__vFtvyG__textInput",
  "thumb": "ExtendedSlider-module-scss-module__vFtvyG__thumb",
  "title": "ExtendedSlider-module-scss-module__vFtvyG__title",
});
